import config from '@/assets/config'
import { getFrames } from '@/utils'

const ww = window.innerWidth
const wh = window.innerHeight

// 场景基础数据
const s3ScrollD = config.scenesScrollD[2]
const s3ScrollT = config.scenesScrollT[2]
const s4ScrollD = config.scenesScrollD[3]
const s4ScrollT = config.scenesScrollT[3]

// 静态
const s4StaticFadeD = s3ScrollD + s3ScrollT * 0.9
const s4StaticFadeT = s3ScrollT * 0.1 + s3ScrollT * 0.1

// 找出场景三时钟中心位置
const s3BgW = wh * 2600 / 2436
const s3BgScrollW = s3BgW - ww
const s3DoorW = wh * 0.511 * 704 / 1244
const s3DoorX = 470 * s3BgW / 2600
const s3ClockH = wh * 0.1
const s3ClockX = s3DoorX + s3DoorW + 1034 / 2600 * s3BgW + s3ClockH / 2 - s3BgScrollW
const s3ClockY = 0.243 * wh + s3ClockH / 2
// 场景
const s4StaticH = s3ClockH / (243 / 3980)
const s4StaticW = s4StaticH * 3819 / 3980
// 场景四时钟中心位置
const s4StaticCX = s4StaticW * 1364 / 3819
const s4StaticCY = s4StaticH * 610 / 3980
// 场景四起始偏移值
const s4StaticX = s3ClockX - s4StaticCX
const s4StaticY = s3ClockY - s4StaticCY

// 移动
const s4StaticH2 = wh
const s4StaticW2 = wh * 3819 / 3980
const s4StaticMoveT = s4ScrollT * 0.2
const s4StaticMoveD = s4ScrollD + s4ScrollT * 0.1

// 翻页
const s4PageD = s4ScrollD + s4ScrollT * 0.9
const s4PageT = s4ScrollT * 0.1
const s4PageW = ww

const s4StaticMoveD2 = s4StaticMoveD + s4StaticMoveT
const s4StaticMoveT2 = s4ScrollT * 0.2

// 缩放
const s4StaticScaleD = s4StaticMoveD2 + s4StaticMoveT2 // 0.5T
const s4StaticScaleT = s4ScrollT * 0.2
const s4StaticW3 = 3819 / 0.66 * s4PageW / 1125
const s4StaticH3 = 3980 / 0.66 * s4PageW / 1125
const s4StaticScaleLeft = 2188 / 3819 * s4StaticW3
const s4StaticScaleTop = (1 - (384 / 3980)) * s4StaticH3 - wh

const s4TextD = s4ScrollD + s4ScrollT * 0.95
const s4TextT = s4ScrollT * 0.05

const s4TalkD = s4StaticScaleD + s4StaticScaleT
const s4TalkT = s4ScrollT * 0.05
const s4TalkH = 727 / 2436 * wh
const s4TalkW = s4TalkH * 184 / 727

const animations = {
  s4_staticnew: [
    {
      delay: s4StaticMoveD2,
      duration: s4StaticMoveT2,
      from: { x: 0 },
      to: { x: -s4StaticW2 + ww }
    },
    {
      delay: s4StaticScaleD,
      duration: s4StaticScaleT,
      from: { x: -s4StaticW2 + ww, y: 0, width: s4StaticW2, height: s4StaticH2 },
      to: { x: -s4StaticScaleLeft, y: -s4StaticScaleTop, width: s4StaticW3, height: s4StaticH3 }
    },
    {
      delay: s4PageD,
      duration: s4PageT * 0.001,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s4StaticFadeD,
      duration: s4StaticFadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s4StaticMoveD,
      duration: s4StaticMoveT,
      from: { x: s4StaticX, y: s4StaticY, width: s4StaticW, height: s4StaticH },
      to: { x: 0, y: 0, width: s4StaticW2, height: s4StaticH2 }
    }
  ],
  s4_page: [
    {
      delay: s4PageD + s4PageT * 0.999,
      duration: s4PageT * 0.001,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s4PageD,
      duration: s4PageT * 0.001,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s4PageD,
      duration: s4PageT,
      frames: getFrames('s4_page', 9, 1)
    }
  ],
  s4_text: [
    {
      delay: s4TextD,
      duration: s4TextT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s4TextT * 5 }
    }
  ],
  s4_talk: [
    {
      delay: s4TalkD,
      duration: s4TalkT,
      from: { alpha: 0, width: 0, height: 0 },
      to: { alpha: 1, width: s4TalkW, height: s4TalkH, yoyo: true, repeat: 1, repeatDelay: s4TalkT * 2 }
    }
  ]
}

export default animations



// WEBPACK FOOTER //
// ./src/assets/scenes/s4/spritesAnimations.js